(function($, undefined) {

	'use strict';
	var accordionHeader;

	var toggleAccordion = function() {
		var t = $(this);
		var ctn = t.closest('.accordion-outer-ctn');

		ctn.toggleClass('open');
		ctn.find('.accordion-content').slideToggle();
	};

	var init = function() {
		accordionHeader = $('.accordion-header');

		accordionHeader.click(toggleAccordion);

		var autoOpenHeader = accordionHeader.filter('.auto-open');

		if (autoOpenHeader.length)
			autoOpenHeader.click();
	};
	
	$(window).ready(function () {
		init();
	});

})(jQuery);

